// Module
var code = "<md-icon ng-if=\"$ctrl.routeId\" md-svg-icon=\"route\" class=\"bringoz-icon margin-left-0\" aria-label=\"Routed\"> <md-tooltip>{{$ctrl.routeId}}</md-tooltip> </md-icon> ";
// Exports
export default code;